module.exports = __webpack_public_path__ + "static/media/DesktopFormImage.5f77f09b.png";